import { SeoService } from './../../services/seo.service';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LayoutComponent } from './layout/layout.component';
// import { AsideLeftMinimizeDefaultEnabledComponent } from '../pages/aside-left-minimize-default-enabled/aside-left-minimize-default-enabled.component';
import { HeaderNavComponent } from './header-nav/header-nav.component';
import { DefaultComponent } from '../pages/default/default.component';
import { FooterComponent } from './footer/footer.component';
import { ScrollTopComponent } from './scroll-top/scroll-top.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
// import { HrefPreventDefaultDirective } from '../../_directives/href-prevent-default.directive';
// import { UnwrapTagDirective } from '../../_directives/unwrap-tag.directive';

let AppComponents = []
let refs = require.context('../../components', true, /.ts$/)
refs.keys().forEach(path => {

	let obj = refs(path)
	let component = obj[Object.keys(obj)[0]]

	AppComponents.push(component)
})

let baseRefs = require.context('../../base-components', true, /.ts$/)
baseRefs.keys().forEach(path => {

	let obj = baseRefs(path)
	let component = obj[Object.keys(obj)[0]]

	AppComponents.push(component)
})


// From Component
// import { FormContentAddComponent } from '../../base-components/form/form-content-add/base.component';
// import { FormGroupComponent } from '../../base-components/form/form-group/base.component';
// import { InputTextAddonsComponent } from '../../base-components/form/input-addons/base.component';
// import { InputBrowseComponent } from '../../base-components/form/input-browse/base.component';
// import { InputCheckboxComponent } from '../../base-components/form/input-checkbox/base.component';
// import { InputDateComponent } from '../../base-components/form/input-date/base.component';
// import { InputDateRangeComponent } from '../../base-components/form/input-daterange/base.component';
// import { InputRadioComponent } from '../../base-components/form/input-radio/base.component';
// import { Select2Component } from '../../base-components/form/input-select2/base.component';
// import { SelectAllComponent } from '../../base-components/form/input-select-all/base.component';
// import { Select2NotLabelComponent } from '../../base-components/form/input-select2-not-label/base.component';
// import { InputTextComponent } from '../../base-components/form/input-text/base.component';
// import { InputFileComponent } from '../../base-components/form/input-file/base.component';
// import { InputTextAreaComponent } from '../../base-components/form/input-textarea/base.component';
// import { InputDateMaterialComponent } from '../../base-components/form/input-date-material/base.component';
// import { InputSearchComponent } from '../../base-components/form/input-search/base.component';



// //Botton R
// import { ButtonDeleteRComponent } from '../../base-components/button/btn-delete-r/button.component';
// import { ButtonEditRComponent } from '../../base-components/button/btn-edit-r/button.component';
// import { ButtonViewRComponent } from '../../base-components/button/btn-view-r/button.component';
// import { ButtonNewRComponent } from '../../base-components/button/btn-new-r/button.component';
// //Botton
// import { ButtonSaveComponent } from '../../base-components/button/btn-save/button.component';
// import { ButtonCancelComponent } from '../../base-components/button/btn-cancel/button.component';
// import { ButtonSelectComponent } from '../../base-components/button/btn-select/button.component';
// import { ButtonFormAddComponent } from '../../base-components/button/btn-form-add/button.component';
// import { ButtonFormEditComponent } from '../../base-components/button/btn-form-edit/button.component';

// //ModalLargeComponent
// import { ModalLargeComponent } from '../../base-components/modal/modal/modal.component';
// import { ModalSearchProductComponent } from '../../base-components/modal/modal-search-product/modal.component';
// import { ModalSearchStockComponent } from '../../base-components/modal/modal-search-stock/modal.component';
// import { ModalSearchCountingproductComponent } from '../../base-components/modal/modal-search-countingproduct/modal.component';
// import { ModalAddProductComponent } from '../../base-components/modal/modal-add-product/modal.component';
// import { ModalCopyListProductComponent } from '../../base-components/modal/modal-copylist-product/modal.component';
// import { ModalSellerComponent } from '../../base-components/modal/modal-seller/modal.component';
// import { ModalContactComponent } from '../../base-components/modal/modal-contact/modal.component';
// import { ModalListBuyComponent } from '../../base-components/modal/modal-list-buy/modal.component';



// // Content
// import { ContentLabelComponent } from '../../base-components/content/content-label/index.component';
// import { CotentPersonComponent } from '../../base-components/content/content-person/content.component';
// import { CotentPOSCustomerComponent } from '../../base-components/content/content-pos-customer/content.component';
// import { MenuIconComponent } from '../../base-components/content/menu-icon/content.component';
// import { AppBreadcrumb } from '../../base-components/content/app-breadcrumb/index.component';
// import { PagingBottomComponent } from '../../base-components/content/paging-bottom/content.component';


// Loyout


import { ErpApiService } from '../../services/erp-api.service';


@NgModule({
	providers: [
		ErpApiService,
		SeoService
	],
	declarations: [
		...AppComponents,
		LayoutComponent,
		// AsideLeftMinimizeDefaultEnabledComponent,
		HeaderNavComponent,
		DefaultComponent,
		FooterComponent,
		ScrollTopComponent,
		// HrefPreventDefaultDirective,
		// UnwrapTagDirective,

		//Form
		// FormContentAddComponent,
		// FormGroupComponent,
		// InputTextAddonsComponent,
		// InputBrowseComponent,
		// InputCheckboxComponent,
		// InputFileComponent,
		// InputDateComponent,
		// InputSearchComponent,
		// InputRadioComponent,
		// Select2Component,
		// Select2NotLabelComponent,
		// InputTextComponent,
		// InputTextAreaComponent,
		// InputDateRangeComponent,
		// SelectAllComponent,
		// InputDateMaterialComponent,

		// //Button R
		// ButtonDeleteRComponent,
		// ButtonEditRComponent,
		// ButtonViewRComponent,
		// ButtonNewRComponent,
		// ButtonFormAddComponent,
		// ButtonFormEditComponent,

		// //Button
		// ButtonSaveComponent,
		// ButtonCancelComponent,
		// ButtonSelectComponent,

		// //Modal
		// ModalLargeComponent,
		// ModalSearchProductComponent,
		// ModalSearchStockComponent,
		// ModalSearchCountingproductComponent,
		// ModalAddProductComponent,
		// ModalCopyListProductComponent,
		// ModalSellerComponent,
		// ModalContactComponent,
		// ModalListBuyComponent,



		// // Content
		// ContentLabelComponent,
		// CotentPersonComponent,
		// CotentPOSCustomerComponent,
		// MenuIconComponent,
		// AppBreadcrumb,
		// PagingBottomComponent,

		// Layout

	],
	exports: [
		...AppComponents,
		LayoutComponent,
		// AsideLeftMinimizeDefaultEnabledComponent,
		HeaderNavComponent,
		DefaultComponent,
		FooterComponent,
		ScrollTopComponent,
		// HrefPreventDefaultDirective,

		//Form
		// FormContentAddComponent,
		// FormGroupComponent,
		// InputTextAddonsComponent,
		// InputBrowseComponent,
		// InputCheckboxComponent,
		// InputFileComponent,
		// InputDateComponent,
		// InputSearchComponent,
		// InputRadioComponent,
		// Select2Component,
		// Select2NotLabelComponent,
		// InputTextComponent,
		// InputTextAreaComponent,
		// InputDateRangeComponent,
		// SelectAllComponent,
		// InputDateMaterialComponent,

		// //Button R
		// ButtonDeleteRComponent,
		// ButtonEditRComponent,
		// ButtonViewRComponent,
		// ButtonNewRComponent,
		// ButtonFormAddComponent,
		// ButtonFormEditComponent,

		// //Button
		// ButtonSaveComponent,
		// ButtonCancelComponent,
		// ButtonSelectComponent,

		// //Modal
		// ModalLargeComponent,
		// ModalSearchProductComponent,
		// ModalSearchStockComponent,
		// ModalSearchCountingproductComponent,
		// ModalAddProductComponent,
		// ModalCopyListProductComponent,
		// ModalSellerComponent,
		// ModalContactComponent,
		// ModalListBuyComponent,

		// // Content
		// ContentLabelComponent,
		// CotentPersonComponent,
		// CotentPOSCustomerComponent,
		// MenuIconComponent,
		// AppBreadcrumb,
		// PagingBottomComponent,

		// Layout

	],
	imports: [
		FormsModule,
		CommonModule,
		RouterModule,
	]
})
export class LayoutModule {
}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/layout.module.ts